<template>
  <div class="pageTools">
    <page-banner
      :info="{
        url: require('@img/banner_4.jpg'),
        title: this.$t(`tools.bannerTitle`),
        text: this.$t(`tools.bannerText`),
      }"
    ></page-banner>
    <div class="content">
      <img class="contentBg" src="@img/img_tool@2x.png" alt />
      <div class="container">
        <part-title
          class="wow fadeInUp"
          :title="this.$t(`tools.title`)"
        ></part-title>
        <div class="toolsList">
          <div class="flex-row" v-for="index in 2" :key="index">
            <div
              class="toolsItem"
              :class="{
                last: itemIndex == 3,
                'active animate__animated animate__headShake':
                  toolsActiveIndex == (index - 1) * 3 + (itemIndex - 1),
              }"
              v-for="itemIndex in 3"
              :key="itemIndex"
              @mouseover="
                hoverToolsItem(toolsInfo[(index - 1) * 3 + (itemIndex - 1)])
              "
            >
              <img
                class="icon wow fadeInUp"
                :data-wow-delay="0.1 + (itemIndex - 1) * 0.05 + 's'"
                :src="
                  toolsActiveIndex == (index - 1) * 3 + (itemIndex - 1)
                    ? toolsInfo[(index - 1) * 3 + (itemIndex - 1)].activeIcon
                    : toolsInfo[(index - 1) * 3 + (itemIndex - 1)].icon
                "
                alt
              />
              <h4
                class="wow fadeInUp"
                :data-wow-delay="0.2 + (itemIndex - 1) * 0.05 + 's'"
              >
                {{
                  $t(
                    `tools.toolsInfo.${
                      toolsInfo[(index - 1) * 3 + (itemIndex - 1)].title
                    }`
                  )
                }}
              </h4>
              <p
                class="wow fadeInUp"
                :data-wow-delay="0.3 + (itemIndex - 1) * 0.05 + 's'"
              >
                {{
                  $t(
                    `tools.toolsInfo.${
                      toolsInfo[(index - 1) * 3 + (itemIndex - 1)].text
                    }`
                  )
                }}
              </p>
              <div
                class="more wow fadeInUp"
                :data-wow-delay="0.4 + (itemIndex - 1) * 0.1 + 's'"
                @click="knowMore((index - 1) * 3 + (itemIndex - 1))"
              >
                <span>{{ $t("tools.getMore") }} ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
    <page-dialog
      ref="pageDialog"
      :type="dialogType"
      :title="toolsInfo[dialogType]"
    >
      <div class="dialogContent" slot="content">
        <img
          class="dialogImg"
          :src="dialogInfoList[dialogType].img"
          :class="dialogType === 3 ? 'shorterImg' : ''"
          alt
        />
        <div class="textList">
          <div
            class="textItem"
            v-for="(text, index) in dialogInfoList[dialogType].textList"
            :key="index"
          >
            <span class="dot"></span>
            <p>{{ $t(`tools.dialogInfoList.text${text}`) }}</p>
          </div>
        </div>
      </div>
    </page-dialog>
  </div>
</template>

<script>
import partTitle from "@/components/title";
import pageFooter from "@/components/footer";
import pageBanner from "@/components/banner";
import pageDialog from "@/components/dialog";
import { WOW } from "wowjs";
export default {
  components: {
    pageBanner,
    partTitle,
    pageFooter,
    pageDialog,
  },
  data() {
    return {
      wow: "",
      toolsActiveIndex: -1,
      toolsInfo: [
        {
          icon: require("@img/ico_r_test@2x.png"),
          activeIcon: require("@img/ico_s_r_test@2x.png"),
          title: `title1`,
          text: "text1",
          index: 0,
        },
        {
          icon: require("@img/ico_r_agent@2x.png"),
          activeIcon: require("@img/ico_s_r_agent@2x.png"),
          title: "title2",
          text: "text2",
          index: 1,
        },
        {
          icon: require("@img/ico_r_accuracy@2x.png"),
          activeIcon: require("@img/ico_s_r_accuracy@2x.png"),
          title: "title3",
          text: "text3",
          index: 2,
        },
        {
          icon: require("@img/ico_r_toverall situation@2x.png"),
          activeIcon: require("@img/ico_s_r_toverall situation@2x.png"),
          title: "title4",
          text: "text4",
          index: 3,
        },
        {
          icon: require("@img/ico_r_sensitivity@2x.png"),
          activeIcon: require("@img/ico_s_r_sensitivity@2x.png"),
          title: "title5",
          text: "text5",
          index: 4,
        },
        {
          icon: require("@img/ico_r_sequence@2x.png"),
          activeIcon: require("@img/ico_s_r_sequence@2x.png"),
          title: "title6",
          text: "text6",
          index: 5,
        },
      ],
      dialogInfoList: [
        {
          img: require("@img/product/logo_sur/doe1205.png"),
          textList: ["1_1", "1_2", "1_3"],
        },
        {
          img: require("@img/product/logo_sur/1204_sur.png"),
          textList: ["2_1", "2_2", "2_3", "2_4"],
        },
        {
          img: require("@img/product/logo_sur/errr_2.png"),
          textList: ["3_1", "3_2", "3_3"],
        },
        {
          img: require("@img/product/logo_sur/opt_1.png"),
          textList: ["4_1", "4_2"],
        },
        {
          img: require("@img/product/logo_sur/ana_1.png"),
          textList: ["5_1", "5_2", "5_3"],
        },
        {
          img: require("@img/product/logo_sur/infill.gif"),
          textList: ["6_1", "6_2", "6_3"],
        },
      ],
      dialogType: 0,
    };
  },
  created() {
    this.wow = new WOW({
      animateClass: "animated",
    });
    this.wow.init();
  },
  methods: {
    hoverToolsItem(item) {
      this.toolsActiveIndex = item.index;
    },
    knowMore(type) {
      this.dialogType = type;
      this.$refs.pageDialog.showDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
.pageTools {
  .content {
    position: relative;
    .contentBg {
      position: absolute;
      right: 0;
      top: 0;
      width: 624px;
      height: 450px;
      z-index: -1;
    }
    .container {
      padding-top: 70px;
      .toolsList {
        margin-top: 100px;
        padding-bottom: 100px;
        .flex-row {
          display: flex;
          align-items: center;
          width: 100%;
          margin-bottom: 56px;
          .toolsItem {
            width: 384px;
            height: 460px;
            padding: 56px 48px 42px 48px;
            box-sizing: border-box;
            background: #f1f7ff;
            border-radius: 16px;
            border: 1px solid #d8dbdf;
            margin-right: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            text-align: justify;
            &.last {
              margin-right: 0;
            }
            .icon {
              width: 88px;
              height: 88px;
              margin-bottom: 20px;
            }
            h4 {
              font-size: 28px;
              color: #333333;
              margin-bottom: 22px;
              font-weight: normal;
            }
            p {
              font-size: 18px;
              color: rgba(51, 51, 51, 0.7);
              line-height: 32px;
              margin-bottom: auto;
            }
            .more {
              cursor: pointer;
              font-size: 14px;
              color: #457dfb;
            }
            &.active {
              background: linear-gradient(180deg, #457dfb 0%, #285bcf 100%);
              box-shadow: 0px 6px 12px 3px rgba(45, 97, 215, 0.4);
              h4,
              p,
              .more {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
.dialogContent {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  display: flex;
  align-items: flex-start;
  .dialogImg {
    height: 310px;
    width: auto;
    margin-right: auto;
  }
  .shorterImg {
    height: 250px;
  }
  .textList {
    width: 520px;
    text-align: justify;
    .textItem {
      display: inline-flex;
      align-items: flex-start;
      margin-bottom: 28px;
      .dot {
        width: 12px;
        height: 12px;
        margin-top: 8px;
        background: #5186ff;
        border-radius: 50%;
        margin-right: 8px;
      }
      p {
        display: inline;
        width: 504px;
        line-height: 28px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/tools.vue